var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTennis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_7198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9365 3.00666C17.8196 1.13648 15.0402 0 12.0003 0C8.17014 0 4.75389 1.80412 2.55536 4.60683C2.497 4.68122 2.52437 4.79175 2.61076 4.83009C4.60065 5.71214 7.27417 6.2107 10.086 6.2107C14.9845 6.2107 18.6106 4.7603 19.9495 3.21295C20.0021 3.15211 19.9967 3.05991 19.9365 3.00666Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8056 16.7265C22.8049 16.7265 22.8041 16.7265 22.8033 16.7265C19.1849 16.7265 15.7536 17.6968 13.1415 19.4587C11.3901 20.64 10.1803 22.0885 9.64729 23.5953C9.61729 23.6802 9.66843 23.7729 9.75688 23.7897C10.4838 23.9277 11.2336 24 12 24C16.8598 24 21.0536 21.0959 22.9385 16.9322C22.9819 16.8362 22.9109 16.7265 22.8056 16.7265Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.585 4.78875C21.5312 4.71731 21.425 4.71089 21.3635 4.77581C19.327 6.92217 14.999 8.30991 10.0857 8.30991C6.84844 8.30991 3.73795 7.69177 1.44398 6.60375C1.37194 6.56963 1.28564 6.59836 1.25011 6.66975C0.450141 8.27634 0 10.0867 0 12C0 17.0023 3.07678 21.2993 7.43719 23.0985C7.51556 23.1309 7.60406 23.0888 7.6312 23.0084C8.29767 21.0345 9.79805 19.1818 11.9677 17.7184C14.9228 15.7252 18.771 14.6274 22.8033 14.6274C23.064 14.6274 23.3241 14.6324 23.5836 14.6412C23.6542 14.6436 23.7169 14.5956 23.7318 14.5264C23.9071 13.7116 24 12.8665 24 12C24 9.29555 23.1002 6.79767 21.585 4.78875Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_7198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/tennis.1a8a5525d1418ee2f16ddd41694fc861.svg";
export { ForwardRef as ReactComponent };